/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IConsumableGroup } from 'app/shared/model/consumable-group.model';
import { IDeviceManufacurer } from 'app/shared/model/device-manufacurer.model';
import { ICatalogDefinitions } from 'app/shared/model/catalog-definitions.model';
import { ConsumableType } from 'app/shared/model/enumerations/consumable-type.model';

export interface IConsumable {
  id?: string;
  type?: keyof typeof ConsumableType | null;
  name?: string;
  addedBy?: string | null;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  unit?: string | null;
  quantity?: string | null;
  price?: number | null;
  cursor?: number;
  microSec?: number;
  group?: IConsumableGroup | null;
  manufacturer?: IDeviceManufacurer | null;
  catalog?: ICatalogDefinitions | null;
}

export const defaultValue: Readonly<IConsumable> = {
  active: false,
};
